var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from 'src/ui/components/modal/Modal';
import styles from './ControlsModal.module.scss';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
import { ControlsModalFilter, } from 'src/ui/views/dynamics/CaseGlobalViewPage/components/modals/ControlsModal/ControlsModalFilters/ControlsModalFilter';
import { useState } from 'react';
import { E_STATUS } from 'src/shared/types';
import { ControlsModalContent } from 'src/ui/views/dynamics/CaseGlobalViewPage/components/modals/ControlsModal/ControlsModalContent/ControlsModalContent';
var getDefaultFilters = function (targetScore) { return ({
    status: [E_STATUS.KO, E_STATUS.UNKNOWN, E_STATUS.OK],
    scoreTags: [targetScore],
    search: '',
}); };
export var ControlsModal = function (props) {
    var i18n = props.i18n, controls = props.controls, onClose = props.onClose;
    var collection = controls.collection, targetScore = controls.targetScore;
    var _a = useState(getDefaultFilters(targetScore)), filters = _a[0], setFilters = _a[1];
    var handleFiltersChange = function (filters) {
        setFilters(filters);
    };
    var handleResetFilter = function () {
        setFilters(getDefaultFilters(targetScore));
    };
    var SCORELESS_TAG = getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.allControls.tags.scoreless');
    var title = getPropsByKeyPath(i18n.keyValueMap, 'caseGlobalView.modals.allControls.title');
    var controlsFiltered = collection.filter(function (control) {
        var scoreTags = control.scoreTags, status = control.status, description = control.description;
        var search = filters.search, scoreTagsFilter = filters.scoreTags, statusFilter = filters.status;
        var isScoreTagsFilterEmpty = scoreTagsFilter.length === 0 && (scoreTags === null || scoreTags === void 0 ? void 0 : scoreTags.length) === 0;
        var isNoScoreTagFilter = scoreTagsFilter.includes(SCORELESS_TAG);
        var isScoreTagMatch = scoreTags === null || scoreTags === void 0 ? void 0 : scoreTags.some(function (scoreTag) { return scoreTagsFilter.includes(scoreTag); });
        var isStatusMatch = statusFilter.includes(status);
        var isSearchMatch = description.toLowerCase().includes(search.toLowerCase());
        if (isScoreTagsFilterEmpty) {
            return false;
        }
        else if (isNoScoreTagFilter && scoreTagsFilter.length === 1) {
            // only SCORELESS_TAG is selected, we retrieve all controls with no score tags
            return (scoreTags === null || scoreTags === void 0 ? void 0 : scoreTags.length) === 0;
        }
        else if (isNoScoreTagFilter && scoreTagsFilter.length > 1) {
            // SCORELESS_TAG is selected and at least one other score tag
            return ((scoreTags === null || scoreTags === void 0 ? void 0 : scoreTags.length) === 0 || isScoreTagMatch) && isStatusMatch && isSearchMatch;
        }
        else {
            return isScoreTagMatch && isStatusMatch && isSearchMatch;
        }
    });
    var scoreTagsMerged = [SCORELESS_TAG].concat(collection.reduce(function (acc, control) {
        var scoreTags = control.scoreTags;
        var scoreTagsNotAlreadyExist = (scoreTags === null || scoreTags === void 0 ? void 0 : scoreTags.filter(function (scoreTag) { return !acc.includes(scoreTag); })) || [];
        return __spreadArray(__spreadArray([], acc, true), scoreTagsNotAlreadyExist, true);
    }, []));
    return (_jsxs(Modal, __assign({ title: title, onClose: onClose, className: styles.controlsModalContainer }, { children: [_jsx(ControlsModalFilter, { i18n: i18n, scoreTags: scoreTagsMerged, targetScore: targetScore, filters: filters, className: styles.controlsModalFilters, onFiltersChange: handleFiltersChange }), _jsx(ControlsModalContent, { i18n: i18n, controls: controlsFiltered, onResetFilter: handleResetFilter, className: styles.controlsModalControlsWrapper })] })));
};
